import React from 'react';
import UnbilledAR from './UnbilledAR';
import AssignmentDetailsLite from './AssignmentDetailsLite';
import ProjectAssignmentRevenueExpenses from './ProjectAssignmentRevenueExpenses';
import ClientAssignmentRevenueExpenses from './ClientAssignmentRevenueExpenses';
import VoidAndReissued from './VoidAndReissued';
import OperationalSubledgerSummary from './OperationalSubledgerSummary';
import OperationalSubledgerDetail from './OperationalSubledgerDetail';
import ClientDepositDetails from './ClientDepositDetail';
import PrepayLineItemsAR from './PrepayLineItemsAr';
import LineItemsAr from './LineItemsAr';
import CreditMemosAr from './CreditMemosAr';
import PrepayCreditMemosAr from './PrepayCreditMemosAr';
import IobList from './IobList';
import ClientAdjustedGrossRevenue from './ClientAdjustedGrossRevenue';
import AssignmentDetails from './AssignmentDetails';
import JournalEntriesReport from './JournalEntriesReport';
import EvaluatorExpenseAnalysisReport from './EvaluatorExpensesAnalysisReport';
import OfficeGrossProfitReport from './OfficeGrossProfitReport';
import TpAssignmentDetails from './TpAssignmentDetails';
import { makeReportOpener } from '../reportNavTools';

// linkClick: the redux link_click action, bound by the admin page.
export default function buildGeneralFinanceReportsSections(linkClick) {
  const open = makeReportOpener(linkClick);

  return [
    {
      title: 'AR & Billing',
      cards: [
        {
          title: 'Unbilled AR',
          description: 'Open the unbilled accounts-receivable report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-file-invoice-dollar',
          onClick: () => open(<UnbilledAR />, 'Unbilled AR', 'reports_unbilledar'),
        },
        {
          title: 'Line Items AR',
          description: 'Open the line-items accounts-receivable report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-list',
          onClick: () => open(<LineItemsAr />, 'Line Items AR', 'reports_lineitemsar'),
        },
        {
          title: 'Prepay Line Items AR',
          description: 'Open the prepaid line-items accounts-receivable report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-list-check',
          onClick: () => open(<PrepayLineItemsAR />, 'Prepay Line Items AR', 'reports_prepaylineitemsar'),
        },
        {
          title: 'Credit Memos AR',
          description: 'Open the credit-memos accounts-receivable report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-receipt',
          onClick: () => open(<CreditMemosAr />, 'Credit Memos AR', 'reports_creditmemosar'),
        },
        {
          title: 'Prepay Credit Memos AR',
          description: 'Open the prepaid credit-memos accounts-receivable report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-receipt',
          onClick: () => open(<PrepayCreditMemosAr />, 'Prepay Credit Memos AR', 'reports_prepaycreditmemosar'),
        },
        {
          title: 'Client Deposit Details',
          description: 'Open the client deposit details report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-piggy-bank',
          onClick: () => open(<ClientDepositDetails />, 'Client Deposit Details', 'reports_clientdepositdetails'),
        },
        {
          title: 'Void and Reissued',
          description: 'Open the void and reissued payments report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-ban',
          onClick: () => open(<VoidAndReissued />, 'Void and Reissued', 'reports_voidandreissued'),
        },
      ],
    },
    {
      title: 'Revenue & Expenses',
      cards: [
        {
          title: 'Assignment Details',
          description: 'Open the assignment revenue and expense details report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-money-bill-wave',
          onClick: () => open(<AssignmentDetails />, 'Assignment Details Report', 'reports_assignmentdetails'),
        },
        {
          title: 'Assignment Details Lite',
          description: 'Open the lightweight assignment details report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-money-bill',
          onClick: () => open(<AssignmentDetailsLite />, 'Assignment Details Lite', 'reports_assignmentdetailslite'),
        },
        {
          title: 'Third-Party Assignment Details',
          description: 'Open the third-party assignment details report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-handshake',
          onClick: () =>
            open(<TpAssignmentDetails />, 'Third-Party Assignment Details Report', 'reports_tpassignmentdetails'),
        },
        {
          title: 'Client Assignment Revenue and Expenses Summary',
          description: 'Open the client-level assignment revenue and expenses summary.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-user-tie',
          onClick: () =>
            open(
              <ClientAssignmentRevenueExpenses />,
              'Client Assignment R. & E. Sum.',
              'reports_clientassignmentrevenueexpenses'
            ),
        },
        {
          title: 'Project Assignment Revenue and Expenses Summary',
          description: 'Open the project-level assignment revenue and expenses summary.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-diagram-project',
          onClick: () =>
            open(
              <ProjectAssignmentRevenueExpenses />,
              'Project Assignment R. & E. Sum.',
              'reports_projectassignmentrevenueexpenses'
            ),
        },
        {
          title: 'Client Adjusted Gross Revenue',
          description: 'Open the client adjusted gross revenue report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-chart-line',
          onClick: () =>
            open(<ClientAdjustedGrossRevenue />, 'Client Adjusted Gross Revenue', 'reports_clientadjustedgrossrevenue'),
        },
        {
          title: 'Office Gross Profit Report',
          description: 'Open the office gross profit report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-building',
          onClick: () => open(<OfficeGrossProfitReport />, 'Office Gross Profit', 'reports_officegrossprofitreport'),
        },
        {
          title: 'Evaluator Expense Analysis Report',
          description: 'Open the evaluator expense analysis report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-magnifying-glass-dollar',
          onClick: () =>
            open(
              <EvaluatorExpenseAnalysisReport />,
              'Evaluator Expense Analysis',
              'reports_evaluatorexpenseanalysisreport'
            ),
        },
      ],
    },
    {
      title: 'Ledger & Accounting',
      cards: [
        {
          title: 'Operational Subledger Detail',
          description: 'Open the operational subledger detail report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-book',
          onClick: () =>
            open(<OperationalSubledgerDetail />, 'Operational Subledger Detail', 'reports_operationalsubledgerdetail'),
        },
        {
          title: 'Operational Subledger Summary',
          description: 'Open the operational subledger summary report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-book-open',
          onClick: () =>
            open(
              <OperationalSubledgerSummary />,
              'Operational Subledger Summary',
              'reports_operationalsubledgersummary'
            ),
        },
        {
          title: 'Journal Entries Report',
          description: 'Open the journal entries report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-pen-to-square',
          onClick: () => open(<JournalEntriesReport />, 'Journal Entries', 'reports_journalentriesreport'),
        },
        {
          title: 'IOB List',
          description: 'Open the inter-office billing (IOB) list report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-arrow-right-arrow-left',
          onClick: () => open(<IobList />, 'IOB List', 'reports_ioblist'),
        },
      ],
    },
  ];
}
